import styles from './no-content.module.scss';

interface NoContentProps {
  title?: string;
  subTitle: string;
}

const NoContent: React.FC<NoContentProps> = ({ title, subTitle }) => {
  return (
    <div className={styles.noContent}>
      <h4>{title}</h4>
      <h5>{subTitle}</h5>
    </div>
  );
};

export default NoContent;
